import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';
import type { VideoModelEntry } from '../types';

const COST_FACTOR = 1.5;

export const lumaModels: VideoModelEntry[] = [
    {
        id: 'ray-3.2',
        chef: providers.luma,
        providers: [
            {
                ...providers.luma,
                model: wavespeed('luma/ray-3.2'),
                getCost: ({ duration, quality }) => {
                    if (quality === '540p') return duration * 0.1 * COST_FACTOR;
                    if (quality === '720p') return duration * 0.2 * COST_FACTOR;
                    if (quality === '1080p') return duration * 0.4 * COST_FACTOR;
                    return duration * 0.4 * COST_FACTOR;
                },
                getPassCount: ({ duration, quality }) => {
                    if (quality === '540p') return duration * 0.1 * 100 * COST_FACTOR;
                    if (quality === '720p') return duration * 0.2 * 100 * COST_FACTOR;
                    if (quality === '1080p') return duration * 0.4 * 100 * COST_FACTOR;
                    return duration * 0.4 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['16:9', '9:16', '4:3', '3:4', '1:1'],
                durations: [5, 10],
                qualities: ['540p', '720p', '1080p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: ['16:9', '9:16', '4:3', '3:4', '1:1'],
                durations: [5, 10],
                qualities: ['540p', '720p', '1080p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
        },
        supportsEdit: false,
        supportsInput: ['t2v', 'first'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    {
        id: 'ray-3.2-video-edit',
        chef: providers.luma,
        providers: [
            {
                ...providers.luma,
                model: wavespeed('luma/ray-3.2/video-edit'),
                getCost: ({ duration, quality }) => {
                    if (quality === '540p') return duration * 0.144 * COST_FACTOR;
                    if (quality === '720p') return duration * 0.216 * COST_FACTOR;
                    if (quality === '1080p') return duration * 0.432 * COST_FACTOR;
                    return duration * 0.432 * COST_FACTOR;
                },
                getPassCount: ({ duration, quality }) => {
                    if (quality === '540p') return duration * 0.144 * 100 * COST_FACTOR;
                    if (quality === '720p') return duration * 0.216 * 100 * COST_FACTOR;
                    if (quality === '1080p') return duration * 0.432 * 100 * COST_FACTOR;
                    return duration * 0.432 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            v2v: {
                aspectRatios: [],
                durations: [5, 10],
                qualities: ['540p', '720p', '1080p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: false },
                    video: { allow: true, maxCount: 1, maxSize: '100MB', minDuration: '5s', maxDuration: '10s', formats: ['video/mp4'] },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            v2v: ['prompt', 'video'],
        },
        supportsEdit: true,
        supportsInput: ['v2v'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    {
        id: 'ray-3.2-video-reframing',
        chef: providers.luma,
        hideInstructions: true,
        providers: [
            {
                ...providers.luma,
                model: wavespeed('luma/ray-3.2/video-reframing'),
                getCost: ({ duration, quality }) => {
                    if (quality === '540p') return duration * 0.06 * COST_FACTOR;
                    if (quality === '720p') return duration * 0.12 * COST_FACTOR;
                    if (quality === '1080p') return duration * 0.36 * COST_FACTOR;
                    return duration * 0.36 * COST_FACTOR;
                },
                getPassCount: ({ duration, quality }) => {
                    if (quality === '540p') return duration * 0.06 * 100 * COST_FACTOR;
                    if (quality === '720p') return duration * 0.12 * 100 * COST_FACTOR;
                    if (quality === '1080p') return duration * 0.36 * 100 * COST_FACTOR;
                    return duration * 0.36 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            v2v: {
                aspectRatios: ['21:9', '16:9', '9:16', '4:3', '3:4', '1:1'],
                durations: [5, 10],
                qualities: ['540p', '720p', '1080p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: false },
                    video: { allow: true, maxCount: 1, maxSize: '100MB', minDuration: '5s', maxDuration: '10s', formats: ['video/mp4'] },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            v2v: ['prompt', 'video'],
        },
        supportsEdit: true,
        supportsInput: ['v2v'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
];